/* Static lander adapter for the existing DaSHEa PDP offer.
   Catalog is a verified public snapshot; Shopify remains authoritative at checkout.
   CTA is a real cart permalink with whole-pack quantities. Nothing is sent on selection. */
(() => {
  'use strict';
  const root = document.querySelector('[data-dhl-offer]');
  if (!root || root.dataset.offerReady) return;
  root.dataset.offerReady = 'true';
  const config = JSON.parse(root.querySelector('[data-offer-data]').textContent);
  const money = cents => new Intl.NumberFormat('cs-CZ', {
    style: 'currency', currency: config.currency, maximumFractionDigits: 0
  }).format(cents / 100);
  const buttons = [...root.querySelectorAll('[data-offer-choice]')];
  const checkout = root.querySelector('[data-offer-checkout]');
  function select(key) {
    const choice = config.choices[key];
    if (!choice || !choice.available) return;
    root.dataset.offerSelection = key;
    buttons.forEach(button => {
      const item = config.choices[button.dataset.offerChoice];
      button.disabled = !item?.available;
      button.setAttribute('aria-pressed', String(button.dataset.offerChoice === key));
    });
    root.querySelector('[data-bundle-count]').textContent = `${choice.label} · ${choice.packLabel}`;
    root.querySelector('[data-bundle-total]').textContent = money(choice.total);
    const subtotal = root.querySelector('[data-bundle-subtotal]');
    subtotal.textContent = money(choice.subtotal);
    subtotal.hidden = choice.saving === 0;
    root.querySelector('[data-bundle-saving-row]').hidden = choice.saving === 0;
    root.querySelector('[data-bundle-saving]').textContent = money(choice.saving);
    const freeShipping = choice.total >= 99900;
    root.querySelector('[data-v3-shipping]').hidden = !freeShipping;
    root.querySelector('[data-offer-checkout-note]').textContent = freeShipping
      ? 'Ceny včetně DPH.' : 'Ceny včetně DPH. Doprava se dopočítá v košíku.';
    root.querySelector('[data-offer-add-label]').textContent = `Do košíku · ${money(choice.total)}`;
    const items = choice.items.map(item => `${item.id}:${item.quantity}`).join(',');
    checkout.href = `https://dashea.cz/cart/${items}?storefront=true`;
    checkout.setAttribute('aria-label', `Přejít do košíku: ${key === 'combo' ? 'obličej, dekolt a oči, ' : ''}${choice.label} za ${money(choice.total)}`);
    const stickyLabel = document.getElementById('stickyLabel');
    if (stickyLabel) stickyLabel.textContent = `${choice.label} · ${money(choice.total)}`;
  }
  buttons.forEach(button => button.addEventListener('click', () => select(button.dataset.offerChoice)));
  select('8');

  const main = root.querySelector('#galMain');
  const thumbs = [...root.querySelectorAll('.dhl-gal__thumbs button')];
  thumbs.forEach(button => button.addEventListener('click', () => {
    main.src = button.dataset.src;
    main.alt = button.dataset.alt || '';
    thumbs.forEach(other => other.setAttribute('aria-current', String(other === button)));
  }));
})();
